import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";
import { parseAppDate } from "@/utils/dates/dateFormats";

export class UpdateCertificationDto {
  @Expose()
  certificationId: string;

  @Expose()
  @Transform(({ value }) => (value ? toCents(value) : value))
  totalAmount?: number;

  @Transform(({ value }) => (value ? parseAppDate(value, false) : value))
  @Expose()
  registrationDate?: Date;

  @Transform(({ value }) => (value ? parseAppDate(value, false) : value))
  @Expose()
  startDate?: Date;

  @Transform(({ value }) => (value ? parseAppDate(value, false) : value))
  @Expose()
  endDate?: Date;

  @Expose()
  contactPerson?: string;

  @Transform(({ value }) => (value ? parseAppDate(value, false) : value))
  @Expose()
  certificationSentDate?: Date;

  @Transform(({ value }) => (value ? parseAppDate(value, false) : value))
  @Expose()
  otReportSentDate?: Date;

  @Expose()
  otQuantity?: number;

  @Transform(({ value }) => (value ? parseAppDate(value, false) : value))
  @Expose()
  clientApprovalDate?: Date;

  @Transform(({ value }) => (value ? parseAppDate(value, false) : value))
  @Expose()
  movedToBillingDate?: Date;
}
